import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ErrorHandler from "../../common/ErrorHandler";
import SubscriptionServices from "../../services/subscription/subscription.service";
import { errorToast, successToast } from "../../react-toastfiy/toast";

function AddLogModal(props) {
  const { onHide, user } = props;
  const [log, setLog] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddLog = () => {
    try {
      setLoading(true);
      let form_data = new FormData();
      form_data.append("phone", user.user_phone);
      form_data.append("message", log);
      SubscriptionServices.CreateUserLogEntry(form_data).then((res) => {
        setLoading(false);
        if (res.status === 200) {
          successToast(res?.msg);
          onHide();
        } else {
          errorToast(res?.msg);
        }
      });
    } catch (error) {
      console.log(error);
      errorToast(error.msg);
      setLoading(false);
    }
  };

  try {
    return (
      <>
        <Modal
          {...props}
          size="md"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <div>
              <span className=" fw-semibold fs-5">Add Follow-Ups</span>
            </div>
          </Modal.Header>
          <Modal.Body>
            {/* <label className="mb-0">Comment</label> */}
            <textarea
              className="form-control"
              value={log}
              onChange={(e) => setLog(e.target.value)}
              name="log_data"
              rows="4"
              required
              placeholder="Type your comment here.."
            ></textarea>
            <div className="d-flex justify-content-end">
              {loading ? (
                <button type="button" className="btn btn-dark mt-4" disabled>
                  Loading..
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-dark mt-4"
                  onClick={() => {
                    if (log === "") {
                      errorToast("Please enter comment");
                    } else {
                      handleAddLog();
                    }
                  }}
                >
                  <i className="bi bi-plus-lg me-2 fs-6 cursor-pointer"></i>
                  Add Follow-Up
                </button>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  } catch (error) {
    return <ErrorHandler error={error} />;
  }
}

export default AddLogModal;
